import { logErrorToNewRelic } from "@repo/shared-utils/newRelic-log-utils";
import { profLoanInsert } from "../../../connection-manager/src/services/profLoanInsert.service";
import {
  getSessionData,
  getVersionedCallbackUrl,
  redirectToWebform,
} from "@repo/shared-utils/common-utils";
import { isOpenInApp } from "@repo/shared-utils/pwa-utils";
import { SSORedirectHandler } from "../../../../apps/trading-mall-app/app/components/ClickHandler/RedirectionConfig.interface";
import { getApplicationId, getApplicationIdAndProdCode, redirectionInAppWebform } from "./utils";
import { V5 } from "../../../connection-manager/src/services/constants";

interface HandlerConfig {
  productCode: "DL" | "CA" | "LFL";
  productName: "DOCTOR" | "LAWYER" | "LOAN FOR CHARTERED ACCOUNTANTS";
  eventCode?: string;
}

export const commonProfHandler = (config: HandlerConfig): SSORedirectHandler => {
  const { productCode, productName, eventCode } = config;

  return async (data) => {
    const { mobileNo, custId, custType } = await getSessionData();
    const [applicationID, prodCode] = await getApplicationIdAndProdCode(data, [productCode]);
    const product = productName;
    let response = undefined;
    const resume = applicationID !== undefined;
    const appVersion = V5;
    const insertJourneyName = "PRO_NTB";
    if (!applicationID) {
      try {
        response = await profLoanInsert({
          mobileNo,
          custId,
          custType,
          journeyName: insertJourneyName,
          appId: await getApplicationId([productCode]),
          appVersion,
          ...data.data?.profInsert,
          ...(eventCode ? { eventCode } : {}),
        });
      } catch (error) {
        logErrorToNewRelic(error as string, {
          errorType: "Error in Prof insert",
        });
      }
    }
    const callbackUrl = await getVersionedCallbackUrl(data.mapping);

    if (isOpenInApp()) {
      redirectionInAppWebform(response?.id ?? applicationID ?? "", productCode);
      return;
    }
    redirectToWebform(callbackUrl.toString(), {
      applicationID: response?.id ?? applicationID,
      custType,
      prodCode: response?.id ? "" : prodCode,
      product,
      resume: response?.id || applicationID ? resume : false,
    });
  };
};
